import * as React from 'react'
import styled from 'styled-components'

const VisualAnalogScaleInput = styled.input.attrs({ type: 'range' })`
  -webkit-appearance: none;
  appearance: none;
  width: 100%;
  height: 8px;
  background: transparent;
  outline: none;
  position: relative;
  z-index: 3; /* Higher z-index to be above the ticks */
  cursor: pointer;

  &::-webkit-slider-thumb {
    -webkit-appearance: none;
    border: 1px solid #000000;
    height: 36px;
    width: 16px;
    border-radius: 3px;
    background: #ffffff;
    cursor: pointer;
    margin-top: -14px;
    box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;
  }

  &::-webkit-slider-runnable-track,
  &::-moz-range-track {
    background: #ddd;
    border-radius: 0;
  }
`

const TicksContainer = styled.div`
  display: flex;
  justify-content: space-between;
  position: absolute;
  width: 100%;
  top: 50%;
  transform: translateY(-50%);
  z-index: 2; /* Lower z-index than the thumb */
`

export const Tick = styled.div<{ large?: boolean }>`
  position: relative;
  width: 2px;
  height: ${({ large }) => (large ? '20px' : '10px')};
  transform: translateY(-50%);
  background: black;
  z-index: 1; /* below the thumb */

  label {
    display: ${({ large }) => (large ? 'block' : 'none')};
    position: absolute;
    top: ${({ large }) => (large ? '30px' : '20px')};
    left: 50%;
    transform: translateX(-50%);
    font-size: 12px;
    white-space: nowrap;
    z-index: 2;
  }
`

const VisualScaleContainer = styled.div`
  margin-top: 5px;
  display: flex;
  flex-direction: column;
  align-items: center;
`

const VisualScaleInnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  width: 100%;
`

const VisualAnalogScaleContainerLabel = styled.div`
  color: ${(props) => props.theme.colors.primary};
  font-size: 16px;
  font-weight: 500;
  line-height: 1.1;
  white-space: normal;
  max-width: 120px;
  margin-top: 2px;
`

const SliderContainer = styled.div`
  position: relative;
  width: calc(100% - 30px);
  margin: 0 15px;
  padding: 40px 0;
`

interface ScaleProps {
  isDisabled?: boolean
  isReadOnly?: boolean
  isValid?: boolean
  id: string
  name: string
  value?: string
  onChange: (e: React.FormEvent<HTMLInputElement>) => void
}

const ScaleValue = styled.div`
  margin: 0 auto;
  margin-top: 2rem;
  font-size: 16pt;
  font-weight: 500;
  flex-shrink: 1;
  text-align: center;
  color: ${(props) => props.theme.colors.primary};
`

export const VisualAnalogScale = ({
  isDisabled,
  id,
  name,
  value,
  onChange,
}: ScaleProps) => {
  const sliderValue = value || '50'
  const displayValue = value || ''

  return (
    <>
      <ScaleValue>
        Your Health Today:
        <br />
        {displayValue}
      </ScaleValue>
      <VisualScaleContainer>
        <VisualScaleInnerContainer>
          <SliderContainer>
            <VisualAnalogScaleInput
              disabled={isDisabled}
              type={`range`}
              min={0}
              max={100}
              id={id}
              name={name}
              value={sliderValue}
              onChange={onChange}
            />
            <TicksContainer>
              {Array.from({ length: 101 }, (_, index) => {
                const isLargeTick = index % 10 === 0
                return (
                  <Tick key={index} large={isLargeTick}>
                    {isLargeTick && <label>{index}</label>}
                  </Tick>
                )
              })}
            </TicksContainer>
          </SliderContainer>
          <div style={{ display: 'flex', width: '100%' }}>
            <VisualAnalogScaleContainerLabel
              style={{ marginLeft: '15px', textAlign: 'left' }}
            >
              The worst health you can imagine
            </VisualAnalogScaleContainerLabel>
            <div style={{ flex: 1 }} />
            <VisualAnalogScaleContainerLabel
              style={{ marginRight: '15px', textAlign: 'right' }}
            >
              The best health you can imagine
            </VisualAnalogScaleContainerLabel>
          </div>
        </VisualScaleInnerContainer>
      </VisualScaleContainer>
    </>
  )
}
